import React, { useContext } from 'react';
import { I18n } from 'common/i18n';
import {
  ForgeButton,
  ForgeCheckbox,
  ForgeDivider,
  ForgeIcon,
  ForgeIconButton,
  ForgeList,
  ForgeListItem,
  ForgeSwitch,
  ForgeToolbar,
} from '@tylertech/forge-react';
import { VideoSourcesContext, ITopic } from './VideoSourcesProvider';

type Props = {
  hideDrawer?: () => void;
};

function Filters(props: Props) {
  const { hideDrawer } = props;
  const {
    availableTopics = [],
    selectedTopics = [],
    setSelectedTopics = () => {},
    filterByAudience = true,
    setFilterByAudience = () => {},
  } = useContext(VideoSourcesContext);
  const scope = 'shared.components.videos';

  const renderTopicCheckbox = (topic: ITopic, index: number) => {
    const isSelected = selectedTopics.indexOf(topic.key) > -1;
    const handleSelect = () => {
      let newTopics: string[] = [];
      if (isSelected) {
        newTopics = selectedTopics.filter(t => t !== topic.key);
      } else {
        newTopics = [...selectedTopics, topic.key];
      }
      setSelectedTopics(newTopics);
    };

    return (
      (<ForgeListItem key={index} selected={isSelected} on-forge-list-item-select={handleSelect}>
        <ForgeCheckbox slot="start" aria-label={`Select ${topic.label}`}>

        </ForgeCheckbox>
        <span className="forge-typography--body2" aria-hidden="true">{topic.label}</span>
      </ForgeListItem>)
    );
  };

  const resetFilters = () => {
    setSelectedTopics([]);
  };

  const countSelectedTopics = selectedTopics.length;

  return (<>
    <ForgeToolbar>
      <div slot="start" className="forge-typography--subheading4">{I18n.t('filters', { scope })}</div>
      {hideDrawer && (
        <ForgeIconButton slot="end" onClick={hideDrawer} aria-label="close">
          <ForgeIcon name="close" />
        </ForgeIconButton>
      )}
    </ForgeToolbar>
    <ForgeToolbar>
      <div slot="start" className="forge-typography--label1">
        {countSelectedTopics}{' '}
        {I18n.t('applied_filters', { scope, count: countSelectedTopics })}
      </div>
      <ForgeButton slot="end" onClick={resetFilters}>{I18n.t('reset_all', { scope })}</ForgeButton>
    </ForgeToolbar>
    <div className="video-guides-filter-section-title forge-typography--body2">{I18n.t('topics', { scope })}</div>
    <ForgeList className="video-guides-filters">
      {availableTopics.map(renderTopicCheckbox)}
    </ForgeList>
    <ForgeDivider />
    <div className="video-guides-filter-toggle-section">
      <p className="forge-typography--label1">{I18n.t('show_all_videos', { scope })}</p>
      <div>
        <ForgeSwitch
          on={filterByAudience}
          on-forge-switch-change={(event: CustomEvent) => { setFilterByAudience(event.detail); }}
        >
          <span className="forge-typography--body1">{I18n.t('show_all_toggle', { scope })}</span>
        </ForgeSwitch>
      </div>
    </div>
  </>);
}

export default Filters;
